export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How do I receive Tap Dance Teacher Ready after purchasing?',
    answer:
      'You receive immediate access to the complete teaching system after your purchase so you can begin exploring and using the material right away.',
  },
  {
    question:
      'Is this designed for beginner instructors or experienced Tap Dance teachers?',
    answer:
      'Both. The system gives newer instructors the structure they need while providing experienced teachers with a deep library of lessons, progressions, corrections, rhythm work, advanced content, creative activities, assessment systems, and planning tools that can save significant preparation time.',
  },
  {
    question: 'What student levels does it cover?',
    answer:
      'The complete system covers beginner, intermediate, advanced, and performance-focused Tap Dance instruction.',
  },
  {
    question: 'Does it only contain lesson plans?',
    answer:
      'No. The 150 lessons are only one part of the system. Tap Dance Teacher Ready also covers technique, curriculum development, rhythm, musicality, improvisation, advanced training, performance, corrections, assessment, student progression, teaching decisions, creative activities, recital preparation, and instructor business systems.',
  },
  {
    question: 'Why do you call it a 6-in-1 system?',
    answer:
      'Because the core product combines six complete professional teaching volumes, each solving a different major part of Tap Dance instruction: technique, beginner curriculum, intermediate development, advanced training, rhythm and creativity, and complete lessons with planning and assessment. They are designed to work together as one complete system.',
  },
  {
    question: 'Can I use it if I teach different class levels?',
    answer:
      'Yes. The system is specifically structured to help instructors work across different student levels and choose appropriate progressions, lessons, corrections, and teaching strategies.',
  },
  {
    question: 'Can I edit the material?',
    answer:
      'The material is provided as ready-to-use teaching resources and is designed to be used directly as delivered.',
  },
  {
    question: 'Does this work for instructors outside the United States?',
    answer:
      'Yes. Tap Dance Teacher Ready is designed for Tap Dance instructors worldwide.',
  },
  {
    question: 'What currency will I pay in?',
    answer:
      'The checkout automatically displays the applicable payment amount according to your country and available payment options.',
  },
  {
    question: 'What if the material is not useful for me?',
    answer:
      'Your purchase is protected by a 7-day money-back guarantee.',
  },
]
